<template lang="pug">
.alert.alert-success.mt-4(v-if="success")
    font-awesome-icon.mr-2(icon="check")
    | Vielen Dank für Ihre Bewertung!
form(v-else, @submit.prevent="submit")
    .text-center.mt-4
        p.text-danger(v-if="error")
            | Wählen Sie bitte die Anzahl an Sternen aus, die Sie uns geben möchten und schreiben Sie ein paar Sätze zu Ihrer Bewertung
        p Wie viele Sterne geben Sie Luftverbundrechner.de?
        ul.stars
            li.star(v-for="i in 5", :class="{ active: i <= stars }", @click="select(i)")
                span.fa-stack.fa-2x
                    font-awesome-icon.fa-stack-2x(icon="square")
                    font-awesome-icon.fa-stack-1x.fa-inverse(icon="star")
        p Beschreiben Sie Ihre Erfahrung in 2-3 Sätzen:
        textarea.form-control(
            v-model="text",
            rows="4",
            placeholder="bspw. zu der Software selbst, unserem Kundenservice oder Ihrem generellen Eindruck"
        )
        button.btn.btn-primary.mt-4(type="submit") Bewertung abgeben
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faSquare, faStar } from '@fortawesome/free-solid-svg-icons'
import { userService } from '@/services'

library.add(faCheck, faSquare, faStar)

export default {
    data () {
        return {
            stars: null,
            text: '',
            error: false,
            success: false
        }
    },
    methods: {
        select (stars) {
            if (stars > 0 && stars <= 5) {
                this.stars = stars
            }
        },
        async submit () {
            if (!this.stars || !this.text) {
                this.error = true
                return
            }

            try {
                await userService.rate(this.stars, this.text)
                this.success = true
                this.$store.dispatch('authentication/setRated')
            } catch (error) {
                this.$store.dispatch('alert/error', 'Bewertung konnte nicht abgegeben werden')
            }
        }
    }
}
</script>

<style lang="scss">
$active-color: #f3d23e;
$inactive-color: #858585;

.stars {
    font-size: 0.6rem;
    padding: 0;
    list-style-type: none;

    &:hover {
        .star {
            color: $active-color;
        }
    }
}

.star {
    color: $inactive-color;
    cursor: pointer;
    display: inline-block;
    // padding-right: 0.4rem;

    &:hover {
        & ~ .star {
            &:not(.active) {
                color: $inactive-color;
            }
        }
    }

    &.active {
        color: $active-color;
    }
}
</style>
